import clsx from 'clsx';
import React, { useMemo } from 'react';

interface ApplicationCardNeedsHolderProps {
  isCollapsed: boolean;

  className?: string;
}

export const ApplicationCardNeedsHolder: React.FC<ApplicationCardNeedsHolderProps> = ({
  isCollapsed,
  className,
  children,
}) => {
  const needsHolderCn = useMemo(
    () =>
      clsx(
        'lg:grid lg:grid-cols-6 lg:items-start gap-6 overflow-hidden',
        isCollapsed ? 'h-0' : 'h-full mt-3',
        !isCollapsed && className,
      ),
    [isCollapsed],
  );

  return <div className={needsHolderCn}>{children}</div>;
};
